import { ELinks } from '../../util/constants';
import { Box, Link, Typography } from '@mui/material';
import { FC, useContext } from 'react';
import GlobalContext from '../../contexts/GlobalContext';

type TLegalAgreementsProps = {
    onPrivacyClick?: () => void;
    onTermsClick?: () => void;
};

const LegalAgreements: FC<TLegalAgreementsProps> = (props) => {
    const { onPrivacyClick, onTermsClick } = props;
    const { language } = useContext(GlobalContext);

    return (
        <Typography component={'p'} variant={'body2'} data-testid={'legal-agreements'}>
            {language.legal.createAccountAgreement}{' '}
            <Link href={ELinks.privacyPolicy} target="_blank" onClick={onPrivacyClick ? onPrivacyClick : undefined}>
                {language.legal.privacyPolicy}
            </Link>{' '}
            {language.common.and}{' '}
            <Link href={ELinks.termsServiceConsumer} target="_blank" onClick={onTermsClick ? onTermsClick : undefined}>
                {language.legal.termsUse}
            </Link>
        </Typography>
    );
};

export default LegalAgreements;
